/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckSquareIcon20Regular = forwardRef('CheckSquareIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M14.329 7.992a.75.75 0 0 0-1.06-1.06l-4.175 4.173a.5.5 0 0 1-.707 0L6.732 9.45a.75.75 0 1 0-1.061 1.061l1.655 1.655a2 2 0 0 0 2.829 0l4.174-4.174Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 2.25A3.75 3.75 0 0 0 2.25 6v8A3.75 3.75 0 0 0 6 17.75h8A3.75 3.75 0 0 0 17.75 14V6A3.75 3.75 0 0 0 14 2.25H6ZM3.75 6A2.25 2.25 0 0 1 6 3.75h8A2.25 2.25 0 0 1 16.25 6v8A2.25 2.25 0 0 1 14 16.25H6A2.25 2.25 0 0 1 3.75 14V6Z" })));
});
